import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { RECIPIENT_TYPE } from "../constants";
import { Box, Divider, Typography } from "@mui/material";
import DetailBlock from "./DetailBlock";

function OrderRecipientInfo() {
  const { t } = useTranslation();
  const { order } = useOutletContext();
  const recipientMap = useMemo(
    () => ({
      [RECIPIENT_TYPE.COMPANY]: t("statuses.legalEntity"),
      [RECIPIENT_TYPE.INDIVIDUAL]: t("statuses.individualPerson"),
    }),
    [t],
  );

  const formatRecipientType = useCallback(
    (recipientKey) => recipientMap[recipientKey] || recipientKey,
    [recipientMap],
  );

  const recipientName =
    order.recipientType === RECIPIENT_TYPE.COMPANY
      ? order.recipientCompanyRepresentative || "-"
      : order.recipientName;
  const recipientType = formatRecipientType(order.recipientType);
  const recipientCompany =
    order.recipientType === RECIPIENT_TYPE.COMPANY ? order.recipientName : "-";
  const recipientGovNumber = order.recipientGovNumber || "-";

  return (
    <>
      <Box className={"flex items-center justify-start mx-4"}>
        <Typography className={"p-2 font-bold smMax:pb-0"}>
          {t("orderTracking.recipientPart")}
        </Typography>
      </Box>
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      <Box className={"flex flex-col mx-4 p-1.5"}>
        <Box className={"flex items-center justify-stretch w-full smMax:flex-wrap"}>
          <DetailBlock
            text={recipientName}
            title={t("orderTracking.recipientName")}
            className={"my-2 md:w-1/3 w-full"}
          />
          <DetailBlock
            text={order.recipientPhone}
            title={t("orderTracking.recipientPhone")}
            className={"my-2 md:w-1/3 w-1/2"}
          />
          <DetailBlock
            text={recipientType}
            title={t("orderTracking.recipientType")}
            className={"my-2 md:w-1/3 w-1/2"}
          />
        </Box>
        <Box
          className={`${order.recipientType === RECIPIENT_TYPE.INDIVIDUAL ? "hidden" : "flex items-center justify-stretch w-full flex-nowrap"}`}
        >
          <DetailBlock
            text={recipientCompany}
            title={t("orderTracking.company")}
            className={"my-2 w-1/2 md:w-1/3"}
          />
          <DetailBlock
            text={recipientGovNumber}
            title={t("orderTracking.companyID")}
            className={"my-2 w-1/2 md:w-1/3"}
          />
          <Box className={"my-2 w-1/3 smMax:hidden"}></Box>
        </Box>
      </Box>
    </>
  );
}

export default OrderRecipientInfo;
